import React from "react";

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error("React render error:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, maxWidth: 520, margin: "40px auto", fontFamily: "sans-serif" }}>
          <h1>BizDr hit a loading problem</h1>
          <p>Please refresh the page or try a different browser.</p>
        </div>
      );
    }

    return this.props.children;
  }
}
